import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Collapse,
  Dialog,
  DialogContent,
  Divider,
  Fade,
  Grid,
  Link,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import { SelectChangeEvent } from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import SearchIcon from '@mui/icons-material/Search';
// import MenuIcon from '@mui/icons-material/Menu';

import { Link as RouterLink, useLocation, useNavigate, useSearchParams, createSearchParams } from 'react-router-dom';

import _ from 'lodash';

import { LoginBtn } from './mainbar';
import { cat_name_namezh_type, InputsType, useJiang } from '../utils/JiangContext';

export type BigSearchPropTypes = {
  setOpenDialog?: Function; // Optional, used for dialog
}

type SmallSearchPropTypes = {
  bigger_than_sm: boolean;
  setOpenDialog: Function;
}

type SearchFieldPropTypes = {
  id: string;
  name: string;
  // list: cat_name_namezh_type[] | string[],
  list: any[], // fix this in the future
  inputs: InputsType,
  setInputs: Dispatch<SetStateAction<InputsType>>,
  bigger_than_md: boolean;
}

const filter_inputs = (inputs: InputsType) => {
  return Object.fromEntries(
    Object.entries(inputs).filter(([_, value]) =>
      value != null && value.toString().trim() !== ''
    )
  )
};

const SearchField = ({ id, name, list, inputs, setInputs, bigger_than_md }: SearchFieldPropTypes) => {
  // Keeping it for future if want to also setting others' inputs
  // const handleChangeold = (event: React.SyntheticEvent<Element, Event>, new_value: string | null) => {
  //   // for name searchfield to update cat searchfield input based on current name's cat
  //   if (id === 'name') {
  //     const i = new_value?.indexOf('-') ?? -1; // if new_value is null, i becomes -1
  //     const cat = i === -1 ? '' : new_value?.slice(0, i) ?? ''; // name might not have a cat
  //     // console.log('in name searchfield and cat is', cat);

  //     if (!cat && new_value !== '') {
  //       setInputs({ ...inputs, [id]: new_value ?? '' });
  //     } else {
  //       setInputs({ ...inputs, 'cat': cat, [id]: new_value ?? '' });
  //     }

  //   } else if (id === 'cat' && !inputs['name'].startsWith(new_value ?? '')) {
  //     setInputs({ ...inputs, [id]: new_value ?? '', 'name': '' });
  //   } else {
  //     setInputs({ ...inputs, [id]: new_value ?? '' });
  //   }
  // };

  const handleChange_autocomplete = (event: React.SyntheticEvent<Element, Event>, new_value: string | null) => {
    setInputs({ ...inputs, [id]: new_value ?? '' });
  }

  const handleChange_select = (event: SelectChangeEvent) => {
    setInputs({ ...inputs, [id]: event.target.value });
  };
  // console.log('inputs', props.inputs[props.name]);

  // process inputs and list
  let inputs_filtered = filter_inputs(inputs);
  inputs_filtered = _.omit(inputs_filtered, 'keywords');
  inputs_filtered = _.omit(inputs_filtered, 'pat');
  // console.log('inputs filtered', inputs_filtered);

  let list_filtered: string[] = id !== 'pat'
    ? _.uniq(list.filter((l) =>
      (Object.entries(inputs_filtered) as [keyof InputsType, string][])
        .every(([key, value]) =>
          key === id || !value || l[key] === value
        )
    ).map((l: cat_name_namezh_type) => l[id as keyof cat_name_namezh_type]).filter(l => l !== '')).sort()
    : list;

  if (id === 'pat' || id === 'namezh') {
    const zhuyinColl = new Intl.Collator('zh-Hant-TW-u-co-zhuyin', {
      usage: 'sort',
      sensitivity: 'accent',
      numeric: true,
      ignorePunctuation: true,
    });

    const enColl = new Intl.Collator('en', {
      usage: 'sort',
      sensitivity: 'base',
      numeric: true,
      ignorePunctuation: true,
    });

    const startsWithLatin = (s: string) => /^[A-Za-z]/.test(s);

    list_filtered = list_filtered.sort((a, b) => {
      const aLatin = startsWithLatin(a);
      const bLatin = startsWithLatin(b);

      if (aLatin !== bLatin) return aLatin ? -1 : 1; // Latin first
      if (aLatin) return enColl.compare(a, b);       // within Latin group
      return zhuyinColl.compare(a, b);               // within Chinese group
    });
  }

  // console.log(id, 'list', list_filtered);

  if (bigger_than_md) {
    return (
      <Autocomplete
        value={inputs[id]}
        onChange={handleChange_autocomplete}
        disablePortal
        options={list_filtered}
        slotProps={{
          popper: {
            style: {
              minWidth: 250,
              maxHeight: 250
            }
            // minWidth for mobile, maxHeight for forcing it to go downward
          },
        }}
        renderInput={(params) =>
          <TextField {...params} label={name} />
        }
      />
    )
  } else {
    return (
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>{name}</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={inputs[id]}
            label='Age'
            onChange={handleChange_select}
          >
            {
              list_filtered.map((l: string) => (
                <MenuItem value={l}>{l}</MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Box>
    )
  }
}

export const BigSearch = (props: BigSearchPropTypes) => {

  const { setOpenDialog } = props;

  const [errorText, setErrorText] = useState<boolean>(false);

  const {
    inputs_init, inputs, setInputs, setInputsImmutable, selection,
    loading, bigger_than_md, setLoading
  } = useJiang();

  const [, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const handleSubmit = () => {
    // console.log('inputs', inputs);
    // props.setQuery({ q: 'hi' });
    const input_filtered = Object.fromEntries(
      Object.entries(inputs).filter(([_, value]) =>
        value != null && value.toString().trim() !== ''
      )
    )
    // console.log('input filtered', input_filtered);
    if (Object.keys(input_filtered).length === 0) {
      setErrorText && setErrorText(true);
    } else {
      setInputsImmutable({ ...inputs }); // update immutable inputs
      // setLoading(true); // I added here because I thought UI wise it is more beautiful, but not necessary function wise
      setSearchParams('');  // or else if query not changed it won't reload
      navigate({
        pathname: '/search',
        search: `?${createSearchParams(input_filtered)}`
      });

      // Mobile settings, close dialog after pressed search
      if (setOpenDialog) { setOpenDialog(false) } // Close dialog if it exists
      // if (setDialogFull) { setDialogFull(false) }
    }
  };

  const handleClear = () => {
    setInputs({ ...inputs_init });
    setErrorText && setErrorText(false);
    // if (setDialogFull) { setDialogFull(true) }
    // props.setQuery('');
    // navigate('/');
  };

  return (
    <>
      {/* <Grid container spacing={2} sx={{ mt: 2, mb: 2, ml: 8, mr: 8, justifyContent: 'center' }}> */}
      <Grid container spacing={2} sx={{ mb: 2, justifyContent: 'center' }}>
        <Grid size={{ xs: 12 }}>
          <Grid container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid size={{ sm: 1 }} />
            <Grid size={{ xs: 12, sm: 10 }} sx={{ display: 'flex', justifyContent: 'center' }}>
              {location.pathname === '/search' &&
                <Link to='/' component={RouterLink}>
                  <Box
                    component='img'
                    src='/title.svg'
                    sx={{
                      height: { xs: 25, sm: 35 },
                    }}
                  />
                </Link>
              }
            </Grid>
            <Grid size={{ sm: 1 }} sx={{ display: 'flex', justifyContent: 'end' }}>
              {
                location.pathname === '/search' && !setOpenDialog
                  // bigsearch is also used in home (/); means bigsearch is not in dialog
                  ?
                  <LoginBtn />
                  : <></>
              }
            </Grid>
          </Grid>
        </Grid>
        {
          selection.map((s: any) => (
            <Grid size={{ xs: 6, md: s.cols }} key={s.name}>
              <SearchField {...s} inputs={inputs} setInputs={setInputs} bigger_than_md={bigger_than_md} />
            </Grid>
          ))
        }
        <Grid size={{ xs: 12 }}>
          <TextField
            id='outlined-basic'
            label='影片名、關鍵字、溝通碼'
            variant='outlined'
            fullWidth
            helperText={'關鍵字1, 關鍵字2...'}
            value={inputs['keywords']}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setInputs({ ...inputs, keywords: event.target.value });
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{
        // justifyContent: 'center',
        alignItems: 'center',
        mb: 2,
      }}>
        <Grid size={{ xs: 12, sm: 4, md: 2 }} offset={{ xs: 0, sm: 2, md: 4 }}>
          <Button
            variant='contained'
            fullWidth
            onClick={() => handleSubmit()}
            loading={loading}
          >
            搜尋
          </Button>
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 2 }}>
          <Button
            variant='outlined'
            fullWidth
            onClick={() => handleClear()}
          >
            清除
          </Button>
        </Grid>
        {location.pathname !== '/' &&
          <>
            <Grid size={{ xs: 12, md: 1 }}>
              <Link sx={{ cursor: 'pointer' }} to='/' component={RouterLink}>
                <Typography variant='body1' align='center'>回首頁</Typography>
              </Link>
            </Grid>
            {!bigger_than_md &&
              <Grid size={{ xs: 12 }}>
                <Typography variant='body2' color='primary.dark' textAlign='center'>本網站只知識分享，不做醫療建議</Typography>
              </Grid>
            }
          </>
        }
      </Grid >
      <Grid container spacing={2} sx={{
        justifyContent: 'center',
        alignItems: 'center',
        mb: bigger_than_md ? 2 : 0
      }
      }>
        <Grid size={{ xs: 12, sm: 4, md: 2 }}>
          {errorText && <Typography color='error' align='center'>尚未輸入查詢內容</Typography>}
        </Grid>
      </Grid >
    </>
  )
}

const SmallSearch = (props: SmallSearchPropTypes) => {
  const { inputs_immutable } = useJiang();
  const { bigger_than_sm } = props;

  const keyToChinese: Record<string, string> = {
    keywords: '',
    cat: '科: ',
    name: '病: ',
    pat: '級: ',
  };

  const display_text: any[] = [];
  const small_search_divider = (key: string) => (
    <Divider orientation='vertical' flexItem key={key + '-divider'}
      sx={(theme) => ({ mr: 1, ml: 1, borderColor: theme.palette.primary.dark })}
    />
  )

  Object.entries(keyToChinese).forEach(([key, value]) => {
    if (key === 'keywords') {
      display_text.push(
        <SearchIcon fontSize='small' sx={{ mr: 0.5 }} key={key + '-icon'} />
      );
      inputs_immutable[key] && display_text.push(
        <Typography variant='body2' key={key} noWrap>
          {inputs_immutable[key]}
        </Typography>
      )

    } else if ((!bigger_than_sm && display_text.length < 2) || bigger_than_sm) { // for small screen show at most 1 filter
      if (key === 'name' && (inputs_immutable['name'] || inputs_immutable['namezh'])) { // special check for name + namezh
        display_text.push( // Push divider ownly if field exists
          small_search_divider(key)
        );
        let text = `${keyToChinese[key]} ${inputs_immutable[key] ?? ''} ${inputs_immutable['namezh'] ?? ''}`;
        display_text.push(
          <Typography variant='body2' key={key} noWrap>
            {`${text}${bigger_than_sm ? '' : '...'}`}
          </Typography>
        );
      } else if (inputs_immutable[key]) {
        display_text.push( // Push divider ownly if field exists
          small_search_divider(key)
        );
        let text = `${keyToChinese[key]} ${inputs_immutable[key] ?? ''}`;
        display_text.push(
          <Typography variant='body2' key={key} noWrap>
            {`${text}${bigger_than_sm ? '' : '...'}`}
          </Typography>
        );
      }
    }
  });

  let mlr = bigger_than_sm ? 4 : 2;

  return (
    <Grid container sx={{ mb: 2, mt: 2, ml: mlr, mr: mlr, justifyContent: 'space-between', alignItems: 'center' }}>
      <Grid size={{ xs: 4, sm: 2 }} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
        {/* {!bigger_than_sm && <IconButton size='small' sx={{ mr: 1 }}><MenuIcon /></IconButton>} */}
        <Link to='/' component={RouterLink}>
          <Box
            component='img'
            src='/title_short.svg'
            sx={{
              height: '40px',
            }}
          />
        </Link>
      </Grid>
      <Grid size={{ xs: 5 }} sx={{
        display: 'flex', justifyContent: bigger_than_sm ? 'center' : 'end',
        pl: bigger_than_sm ? 0 : 1,
      }}>
        <Button
          variant='outlined'
          sx={(theme) => ({
            textTransform: 'none',
            borderWidth: 1.7,
            color: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
          })}
          onClick={() => {
            if (bigger_than_sm) {
              window.scrollTo({ top: 0, behavior: 'auto' });
            } else {
              props.setOpenDialog(true);
            }
          }}
        >
          {display_text}
        </Button>
      </Grid>
      {
        bigger_than_sm ?
          <Grid size={{ sm: 2 }} sx={{ display: 'flex', justifyContent: 'end' }}>
            <LoginBtn />
          </Grid>
          : <></>
      }
    </Grid >
  )
}

const SearchBar = () => {

  const { inputs_immutable, setInputs } = useJiang();

  /* Scrolled settings */
  const [scrolled, setScrolled] = useState(false);
  const [scrollEnabled, setScrollEnabled] = useState(true);
  // const trigger = useScrollTrigger({ threshold: 300 });
  // console.log(trigger); // true if scrollY > 100
  useEffect(() => {
    // console.log('in useeffect, currY', window.scrollY);
    // console.log('scrollEnabled', scrollEnabled);

    // const onScrollE = () => {
    //   const scrollY = window.scrollY;
    //   if (scrollY > 60) {
    //     setScrollEnabled(true);
    //     console.log('scrollE enabled');
    //     window.removeEventListener('scroll', onScrollE);
    //   }
    //   console.log('curr scrollY', scrollY);
    // }

    const onScroll = () => {
      const scrollY = window.scrollY;
      // if (scrollY > 400 && !scrolled) setScrolled(true);
      // if (scrollY > 60) {
      //   setScrolled(true);
      //   setScrollEnabled(false);
      //   window.removeEventListener('scroll', onScroll);
      // }
      // if (scrollY < 50) {
      //   setScrolled(false);
      // }

      if (scrollY > 340) {
        setScrolled(true);
        setInputs({ ...inputs_immutable }); // reset inputs when user scrolls down
      }
      if (scrollY < 50 && scrollEnabled) setScrolled(false);

      // console.log('curr scrollY', scrollY);
    };

    // if (!scrollEnabled) {
    // window.addEventListener('scroll', onScrollE);
    // return () => window.removeEventListener('scroll', onScrollE);
    // } else {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
    // }

  }, [scrolled]);

  /* Mobile dialog settings */
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  const theme = useTheme();
  // const bigger_than_xs = useMediaQuery(theme.breakpoints.up('sm'));
  const bigger_than_sm = useMediaQuery(theme.breakpoints.up('md'));
  const [openDialog, setOpenDialog] = useState<boolean>(!query && !bigger_than_sm); // if no query and mobile, open dialog
  const [dialogFull, setDialogFull] = useState<boolean>(!query); // if no query, dialog should be full screen

  useEffect(() => {
    if (!query && !bigger_than_sm) setOpenDialog(true);  // if mobile and no query, open dialog
  }, [query]);

  return (
    // <ClickAwayListener onClickAway={() => {
    //   console.log('in click away');
    //   // setScrolled(true);
    //   // setOpenModal(false);
    // }}
    // >
    <>
      <AppBar position='sticky' color='inherit'>
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <Box sx={{ width: '100%', maxWidth: '2560px' }}>
            <Fade in={scrolled || !bigger_than_sm} unmountOnExit>
              <Box>
                <SmallSearch bigger_than_sm={bigger_than_sm} setOpenDialog={setOpenDialog} />
              </Box>
            </Fade>
            {bigger_than_sm && (
              <Collapse in={!scrolled}>
                <div style={{ marginLeft: 30, marginRight: 30, marginTop: 20 }}>
                  <BigSearch />
                </div>
              </Collapse>
            )}
          </Box>
        </Box>
      </AppBar>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          setInputs({ ...inputs_immutable });
        }}
        fullScreen={dialogFull}
        PaperProps={{
          sx: {
            mt: dialogFull ? 0 : 3,        // add top margin
            alignSelf: "flex-start" // stick to top rather than center
          },
        }}
      >
        <DialogContent sx={{ marginTop: dialogFull ? 3 : 0 }}>
          <BigSearch
            setOpenDialog={setOpenDialog}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default SearchBar;